/** True when running inside Capacitor iOS/Android shell. */
export const isNativeApp =
  typeof window !== 'undefined' &&
  Boolean(
    (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.(),
  );
export const MOBILE_APP_ID = 'com.dispafy.app';
export const MOBILE_URL_SCHEME = 'dispafy';

/**
 * OAuth / email-confirmation redirect target.
 * Web: same-origin /auth/callback. Native: custom scheme picked up by DeepLinkHandler.
 */
export function authCallbackUrl(redirectPath: string): string {
  const next = encodeURIComponent(redirectPath);
  if (isNativeApp) {
    return `${MOBILE_URL_SCHEME}://auth/callback?next=${next}`;
  }
  if (typeof window === 'undefined') return redirectPath;
  return `${window.location.origin}/auth/callback?next=${next}`;
}

/** OAuth / email-link failure params land in query or hash depending on the flow. */
export function authRedirectErrorFromUrl(raw = typeof window === 'undefined' ? '' : window.location.href): string | null {
  if (!raw) return null;
  try {
    const u = new URL(raw);
    const fromQuery = u.searchParams.get('error_description') || u.searchParams.get('error');
    if (fromQuery) return decodeURIComponent(fromQuery.replace(/\+/g, ' '));
    if (u.hash.length > 1) {
      const fromHash = new URLSearchParams(u.hash.replace(/^#/, ''));
      const fromHashErr = fromHash.get('error_description') || fromHash.get('error');
      if (fromHashErr) return decodeURIComponent(fromHashErr.replace(/\+/g, ' '));
    }
  } catch {
    /* ignore malformed URLs */
  }
  return null;
}

/** Strip auth callback tokens/errors from the address bar after handling. */
export function clearAuthRedirectParams(): void {
  if (typeof window === 'undefined') return;
  const u = new URL(window.location.href);
  for (const key of ['code', 'token', 'error', 'error_description', 'error_code', 'access_token', 'refresh_token', 'type']) {
    u.searchParams.delete(key);
  }
  u.hash = '';
  window.history.replaceState(window.history.state, '', `${u.pathname}${u.search}`);
}

/** Parse dispafy://auth/callback?… or https://dispafy.com/auth/callback?… into app route. */
export function authCallbackRouteFromUrl(raw: string): string | null {
  try {
    const u = new URL(raw);
    const isCustom =
      u.protocol === `${MOBILE_URL_SCHEME}:` &&
      u.hostname === 'auth' &&
      u.pathname === '/callback';
    const isUniversal =
      u.protocol.startsWith('http') &&
      u.pathname === '/auth/callback';
    if (!isCustom && !isUniversal) return null;
    return `/auth/callback${u.search}`;
  } catch {
    return null;
  }
}
